import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  z-index: 10000;\n  background-color: white;\n  min-width: 200px;\n  padding: 10px;\n  border: 1px solid ', ';\n  border-radius: 4px;\n  box-shadow: 0px 1px 2px ', ';\n  left: ', ';\n  top: ', ';\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease-in, visibility 0s linear 0.2s;\n  ', '\n  ', '\n'], ['\n  position: fixed;\n  z-index: 10000;\n  background-color: white;\n  min-width: 200px;\n  padding: 10px;\n  border: 1px solid ', ';\n  border-radius: 4px;\n  box-shadow: 0px 1px 2px ', ';\n  left: ', ';\n  top: ', ';\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease-in, visibility 0s linear 0.2s;\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      transition: opacity 0.2s ease-in, visibility 0s linear 0s;\n      visibility: visible;\n      opacity: 1;\n    '], ['\n      transition: opacity 0.2s ease-in, visibility 0s linear 0s;\n      visibility: visible;\n      opacity: 1;\n    ']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { styles } from 'gipsy-misc';
import media from '../styles/media';

var ContextMenu = function (_PureComponent) {
  _inherits(ContextMenu, _PureComponent);

  function ContextMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContextMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clientY: 0,
      clientX: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContextMenu, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isActive && !prevProps.isActive) {
        var x = this.props.clientX ? this.props.isActive.clientX + this.props.clientX : this.props.isActive.clientX;
        var y = this.props.clientY ? this.props.isActive.clientY + this.props.clientY : this.props.isActive.clientY;

        this.setState({
          clientY: y,
          clientX: x
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          setRef = _props.setRef,
          children = _props.children,
          isActive = _props.isActive;
      var _state = this.state,
          clientX = _state.clientX,
          clientY = _state.clientY;


      return React.createElement(
        Container,
        { ref: setRef, className: 'context-menu', isActive: isActive, clientX: clientX, clientY: clientY },
        children
      );
    }
  }]);

  return ContextMenu;
}(PureComponent);

ContextMenu.propTypes = {
  children: PropTypes.any.isRequired,
  isActive: PropTypes.object
};
export default ContextMenu;


var Container = styled.div(_templateObject, styles.colors.lightGrey, styles.colors.lightGrey, function (_ref2) {
  var clientX = _ref2.clientX;
  return clientX ? clientX + 20 + 'px' : '0px';
}, function (_ref3) {
  var clientY = _ref3.clientY;
  return clientY ? clientY - 20 + 'px' : '0px';
}, media['phone-wide'](_templateObject2), function (_ref4) {
  var isActive = _ref4.isActive,
      clientX = _ref4.clientX,
      clientY = _ref4.clientY;
  return isActive && css(_templateObject3);
});
//# sourceMappingURL=ContextMenu.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ContextMenu/ContextMenu.js
// module id = 819
// module chunks = 0